(function($) {
  function formSubmitAjax($form) {
    return new Promise(function(resolve, reject) {
      $.ajax({
        url : $form.attr('action'),
        type: $form.attr('method'),
        data : $form.serialize(),
        dataType: 'json'
      })
      .done(function(response) {
        resolve(response);
      });      
    });
  }
  
  function refreshCart() {
    window.location.href = '/cart';    
  }
  
  function updateProductImage(product) {
    //console.log(product);
    if (product.variants.length <= 1) {
      return;
    }
    
    if (product.selected_variant.featured_media || product.type == "gift card") {
      $('.product-gallery--viewport--figure[data-media="' + product.selected_variant.featured_media.id + '"]').click();
      
      $('.images-gallery').removeClass('hide');
      $('.images-gallery').slick('setPosition');
      $('.no-variant-image').addClass('hide');      
    }
    else {
      $('.images-gallery').addClass('hide');
      $('.no-variant-image').removeClass('hide');
    }    
  }

  function variantStockStatus() {
    function updateStock(variant) {
      if (product.type == "gift card") {
        return;
      }
      
      var max = variant.inventory_quantity >= 0 ? variant.inventory_quantity : 0;
      $('.variant-stock-status').find('.inventory').text(max);
      $('.product-option-quantity').attr('min', 1);
      $('.product-option-quantity').attr('max', max);
    }
    
    if (!window.product) return;
    
    updateStock(product.selected_variant);
    updateProductImage(product);
    
    $('.single-option-selector').on('change.variant-helper', function(e) {
      var $form = $(e.currentTarget).closest('.shopify-product-form');
      var variant_id = $form.find('select[name=id]').val();
      // check url for soldout variants
      if (!variant_id) {
        variant_id = window.location.search.replace('?variant=', '');
      }
      
      var variant = product.variants.find(function(v) {
        return v.id == variant_id;
      });      
      
      if (!variant) return;
      
      product.selected_variant = variant;
      updateStock(variant);
      
      // Update image gallery
      updateProductImage(product);
    });
  }
  
  function addToCart() {
    $(document).on('click', '.add-to-cart', function(e) {
      e.preventDefault();
      console.log(e);
      var $form = $(e.currentTarget).closest('.shopify-product-form');
      var $btn = $(e.currentTarget);
      var qty = parseInt($form.find('.product-option-quantity').val());
      var max = parseInt($form.find('.product-option-quantity').attr('max'));
      
      if (qty > max) { 
        alert(`Only ${max} in stock.`);
        return false;
      }
      
      formSubmitAjax($form).then(function() {
        window.location.href = '/cart';
      });
    });    
  }
  
  function thumbnailImageColorSelect() {
    $(document).on('click', '.product-gallery--viewport--figure', function(e) {
      var mediaId = $(e.currentTarget).data('media');
      var variant = _product.variants.filter(function(v) {
        return v.hasOwnProperty('featured_media') && v.featured_media.id === mediaId;
      });
      
      if (variant.length) {
        $('.single-option-selector').each(function(index) {
          var $select = $(this);
          var optionIndex = index + 1;
          var option = `option${optionIndex}`;
          var optionValue = variant[0][option];
          
          if ($select.val() !== optionValue) {
            $select.val(optionValue).trigger('change');
          }
        });
      }
    });
  }
  
  function productImagesGallery() {
    if (!window.product) {
      return;
    }
    
    // Remove media for sold out variants
    var variants_soldout = product.variants.filter(function(v) {
      return !v.available;
    });
    var media_soldout = variants_soldout.map(function(v) {
      return v.featured_media && v.featured_media.id;
    });
    
    if (window.product.available) {
      media_soldout.forEach(function(m) {
        if (m) {
          $('.product-gallery--viewport--figure[data-media="' + m + '"]').remove();
        }
      });
    }
    
    $('.images-gallery').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.images-gallery-thumbs'
    });
    
    $('.images-gallery-thumbs').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.images-gallery',
      dots: false,
      focusOnSelect: true,
      prevArrow: '<span class="product-thumbnails-navigation-previous">&#xe601;</span>',
      nextArrow: '<span class="product-thumbnails-navigation-next">&#xe600;</span>'
    });    
  }
  
  $(document).ready(function() {
    thumbnailImageColorSelect();
    productImagesGallery();
    variantStockStatus();
    addToCart();    
  });
})(jQuery);